import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const NotesIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M15.8333 2.49992H12.3467C12.0025 1.53075 11.0867 0.833252 10 0.833252C8.91333 0.833252 7.9975 1.53075 7.65333 2.49992H4.16667C3.24583 2.49992 2.5 3.24575 2.5 4.16659V15.8333C2.5 16.7541 3.24583 17.4999 4.16667 17.4999H15.8333C16.7542 17.4999 17.5 16.7541 17.5 15.8333V4.16659C17.5 3.24575 16.7542 2.49992 15.8333 2.49992ZM10 2.49992C10.46 2.49992 10.8333 2.87325 10.8333 3.33325C10.8333 3.79325 10.46 4.16659 10 4.16659C9.54 4.16659 9.16667 3.79325 9.16667 3.33325C9.16667 2.87325 9.54 2.49992 10 2.49992ZM7.5 14.1666H5.83333V12.4999L10.955 7.37825L12.6217 9.04492L7.5 14.1666ZM13.8217 7.84492L13.2117 8.45492L11.545 6.78825L12.155 6.17825C12.615 5.71825 13.3617 5.71825 13.8217 6.17825C14.2817 6.63825 14.2817 7.38492 13.8217 7.84492Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

NotesIcon.propTypes = {
  sx: PropTypes.object,
};

export default NotesIcon;
